import React, { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import GlobalBanner from './Banner/GlobalBanner'
import { usePageContext } from '@toasttab/shared/src/hooks/usePageContext'
import RegionSwitcher from './RegionSwitcher'
import RegionSwitcherInfoBanner from './RegionSwitcherInfoBanner'
import { SimpleHeaderProps } from './SimpleHeader.d'
import { useScrollPosition } from '@toasttab/shared/src/hooks/useScrollPosition'

const SimpleHeader = ({
  children,
  localizedEntries,
  packageName,
  siteId
}: SimpleHeaderProps) => {
  const pageContext = usePageContext()
  const { headerHeight, setHeaderHeight } = pageContext
  const activeRegionSwitcherInfoBanner =
    pageContext?.activeRegionSwitcherInfoBanner

  const [bannerMaxHeight, setBannerMaxHeight] = useState('0px')
  const bannerRef = useRef<HTMLDivElement>(null)

  const scrollPosition = useScrollPosition()

  // Show top banner only when at top of page (like original Header)
  const showTopBanner =
    scrollPosition <= 0 &&
    ['main', 'onTheLine'].includes(packageName) &&
    activeRegionSwitcherInfoBanner !== undefined

  useEffect(() => {
    if (bannerRef.current) {
      requestAnimationFrame(() => {
        if (showTopBanner) {
          setBannerMaxHeight(`${bannerRef.current?.scrollHeight}px`)
        } else {
          setBannerMaxHeight('0px')
        }
      })
    }
    // Re-set headerHeight when banner state changes
    setTimeout(() => {
      const headHeight =
        typeof document !== 'undefined'
          ? document.querySelector('.headerContent')?.clientHeight
          : 0
      if (headHeight > 0 && headHeight !== headerHeight) {
        setHeaderHeight(headHeight)
      }
    }, 100)
  }, [
    activeRegionSwitcherInfoBanner,
    headerHeight,
    setHeaderHeight,
    showTopBanner
  ])

  const topBannerClasses = classNames(
    'transition-all duration-1000 ease-in-out overflow-hidden'
  )

  const headerClasses = classNames(
    'top-0 w-full z-50 bg-white transition-all sticky z-[100] shadow-[rgba(0,0,0,0)] duration-1000'
  )

  return (
    <header className={headerClasses}>
      <div className='headerContent'>
        {['main', 'onTheLine'].includes(packageName) && (
          <>
            <div
              className={topBannerClasses}
              ref={bannerRef}
              style={showTopBanner ? {} : { maxHeight: bannerMaxHeight }}
            >
              <RegionSwitcherInfoBanner
                localizedEntries={localizedEntries}
                packageName={packageName}
                siteId={siteId}
              />
              {activeRegionSwitcherInfoBanner === false && <GlobalBanner />}
            </div>
            <RegionSwitcher
              localizedEntries={localizedEntries}
              packageName={packageName}
              siteId={siteId}
            />
          </>
        )}
        {children}
      </div>
    </header>
  )
}

export default SimpleHeader
